export default function TestimonialSection() {
  return (
    <section className="relative py-14 md:py-20 px-4 md:px-8 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-500/80 text-foreground-950 text-xs font-semibold mb-4 whitespace-nowrap">
            Depoimentos
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 leading-tight">
            O que dizem / sobre<br />
            Hoobuy Sheet
          </h2>
        </div>

        <div className="columns-1 md:columns-2 lg:columns-3 gap-4 md:gap-5">

          {/* Testimonial 1 */}
          <div className="break-inside-avoid mb-4 md:mb-5 p-5 md:p-6 rounded-2xl bg-background-50">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-11 h-11 md:w-12 md:h-12 rounded-full bg-background-200 overflow-hidden flex-shrink-0">
                <img src="https://readdy.ai/api/search-image?query=Young%20Brazilian%20man%20with%20curly%20dark%20hair%20and%20warm%20smile%2C%20wearing%20white%20t-shirt%2C%20soft%20window%20light%20portrait%2C%20clean%20warm%20background%2C%20friendly%20expression%2C%20modern%20headshot&width=120&height=120&seq=avt-v2-lucas&orientation=squarish" alt="Lucas Oliveira" className="w-full h-full object-cover object-top" loading="lazy" />
              </div>
              <div>
                <p className="font-semibold text-foreground-900 text-sm md:text-base">Lucas Oliveira</p>
                <p className="text-foreground-400 text-xs md:text-sm">@lucasoliver_sp</p>
              </div>
            </div>
            <p className="text-foreground-600 text-sm leading-relaxed">&ldquo;O HoobuySpreadsheet mudou completamente a forma como faço compras internacionais. Antes eu perdia horas comparando preços, agora encontro tudo em minutos. Já economizei mais de R$ 500 este mês!&rdquo;</p>
            <div className="flex items-center gap-1 mt-3">
              {[1,2,3,4,5].map(i => <i key={i} className="ri-star-fill text-accent-500 text-sm w-4 h-4 flex items-center justify-center"></i>)}
            </div>
          </div>

          {/* Testimonial 2 */}
          <div className="break-inside-avoid mb-4 md:mb-5 p-5 md:p-6 rounded-2xl bg-background-50">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-11 h-11 md:w-12 md:h-12 rounded-full bg-background-200 overflow-hidden flex-shrink-0">
                <img src="https://readdy.ai/api/search-image?query=Young%20Brazilian%20woman%20with%20long%20wavy%20brown%20hair%20and%20gentle%20smile%2C%20wearing%20beige%20blouse%2C%20soft%20natural%20light%20portrait%2C%20warm%20neutral%20background%2C%20professional%20friendly%20headshot&width=120&height=120&seq=avt-v2-marina&orientation=squarish" alt="Marina Costa" className="w-full h-full object-cover object-top" loading="lazy" />
              </div>
              <div>
                <p className="font-semibold text-foreground-900 text-sm md:text-base">Marina Costa</p>
                <p className="text-foreground-400 text-xs md:text-sm">@marinacostaf</p>
              </div>
            </div>
            <p className="text-foreground-600 text-sm leading-relaxed">&ldquo;Finalmente uma ferramenta que realmente funciona! Os links são verificados e nunca tive problemas com scams. A planilha é super intuitiva e bem organizada.&rdquo;</p>
            <div className="flex items-center gap-1 mt-3">
              {[1,2,3,4,5].map(i => <i key={i} className="ri-star-fill text-accent-500 text-sm w-4 h-4 flex items-center justify-center"></i>)}
            </div>
          </div>

          {/* Testimonial 3 */}
          <div className="break-inside-avoid mb-4 md:mb-5 p-5 md:p-6 rounded-2xl bg-background-50">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-11 h-11 md:w-12 md:h-12 rounded-full bg-background-200 overflow-hidden flex-shrink-0">
                <img src="https://readdy.ai/api/search-image?query=Young%20Brazilian%20man%20with%20short%20black%20hair%20and%20confident%20smile%2C%20wearing%20grey%20hoodie%2C%20outdoor%20soft%20light%20portrait%2C%20clean%20warm%20background%2C%20casual%20friendly%20headshot&width=120&height=120&seq=avt-v2-pedro&orientation=squarish" alt="Pedro Santos" className="w-full h-full object-cover object-top" loading="lazy" />
              </div>
              <div>
                <p className="font-semibold text-foreground-900 text-sm md:text-base">Pedro Santos</p>
                <p className="text-foreground-400 text-xs md:text-sm">@pedrosantos_br</p>
              </div>
            </div>
            <p className="text-foreground-600 text-sm leading-relaxed">&ldquo;Uso o Hoobuy Spreadsheet há 3 meses e recomendo para todos os meus amigos. A atualização constante dos produtos faz toda a diferença. Sempre encontro as melhores ofertas.&rdquo;</p>
            <div className="flex items-center gap-1 mt-3">
              {[1,2,3,4,5].map(i => <i key={i} className="ri-star-fill text-accent-500 text-sm w-4 h-4 flex items-center justify-center"></i>)}
            </div>
          </div>

          {/* Testimonial 4 */}
          <div className="break-inside-avoid mb-4 md:mb-5 p-5 md:p-6 rounded-2xl bg-background-50">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-11 h-11 md:w-12 md:h-12 rounded-full bg-background-200 overflow-hidden flex-shrink-0">
                <img src="https://readdy.ai/api/search-image?query=Young%20Brazilian%20woman%20with%20shoulder%20length%20blonde%20hair%20and%20bright%20smile%2C%20wearing%20light%20pink%20top%2C%20sunlit%20portrait%20by%20window%2C%20warm%20airy%20background%2C%20happy%20friendly%20headshot&width=120&height=120&seq=avt-v2-ana&orientation=squarish" alt="Ana Beatriz" className="w-full h-full object-cover object-top" loading="lazy" />
              </div>
              <div>
                <p className="font-semibold text-foreground-900 text-sm md:text-base">Ana Beatriz</p>
                <p className="text-foreground-400 text-xs md:text-sm">@anabeatriz_shop</p>
              </div>
            </div>
            <p className="text-foreground-600 text-sm leading-relaxed">&ldquo;Comparar preços nunca foi tão fácil. O HoobuySheet me ajudou a encontrar produtos que eu nem sabia que existiam. A categoria de perfumes é minha favorita!&rdquo;</p>
            <div className="flex items-center gap-1 mt-3">
              {[1,2,3,4].map(i => <i key={i} className="ri-star-fill text-accent-500 text-sm w-4 h-4 flex items-center justify-center"></i>)}
              <i className="ri-star-line text-accent-500 text-sm w-4 h-4 flex items-center justify-center"></i>
            </div>
          </div>

          {/* Testimonial 5 */}
          <div className="break-inside-avoid mb-4 md:mb-5 p-5 md:p-6 rounded-2xl bg-background-50">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-11 h-11 md:w-12 md:h-12 rounded-full bg-background-200 overflow-hidden flex-shrink-0">
                <img src="https://readdy.ai/api/search-image?query=Young%20Brazilian%20man%20with%20styled%20dark%20hair%20and%20cool%20expression%2C%20wearing%20denim%20jacket%2C%20urban%20outdoor%20portrait%2C%20warm%20golden%20light%2C%20clean%20background%2C%20modern%20confident%20headshot&width=120&height=120&seq=avt-v2-rafael&orientation=squarish" alt="Rafael Mendes" className="w-full h-full object-cover object-top" loading="lazy" />
              </div>
              <div>
                <p className="font-semibold text-foreground-900 text-sm md:text-base">Rafael Mendes</p>
                <p className="text-foreground-400 text-xs md:text-sm">@rafamendesz</p>
              </div>
            </div>
            <p className="text-foreground-600 text-sm leading-relaxed">&ldquo;A melhor planilha para quem compra online. Sério, não tem comparação. Economizei tempo e dinheiro desde o primeiro uso. As avaliações e comparações são muito precisas.&rdquo;</p>
            <div className="flex items-center gap-1 mt-3">
              {[1,2,3,4,5].map(i => <i key={i} className="ri-star-fill text-accent-500 text-sm w-4 h-4 flex items-center justify-center"></i>)}
            </div>
          </div>

          {/* Testimonial 6 */}
          <div className="break-inside-avoid mb-4 md:mb-5 p-5 md:p-6 rounded-2xl bg-background-50">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-11 h-11 md:w-12 md:h-12 rounded-full bg-background-200 overflow-hidden flex-shrink-0">
                <img src="https://readdy.ai/api/search-image?query=Young%20Brazilian%20woman%20with%20dark%20curly%20hair%20and%20warm%20laughing%20smile%2C%20wearing%20yellow%20blouse%2C%20bright%20sunlit%20portrait%2C%20warm%20happy%20background%2C%20genuine%20friendly%20headshot&width=120&height=120&seq=avt-v2-juliana&orientation=squarish" alt="Juliana Ferreira" className="w-full h-full object-cover object-top" loading="lazy" />
              </div>
              <div>
                <p className="font-semibold text-foreground-900 text-sm md:text-base">Juliana Ferreira</p>
                <p className="text-foreground-400 text-xs md:text-sm">@julianaferreira</p>
              </div>
            </div>
            <p className="text-foreground-600 text-sm leading-relaxed">&ldquo;Estava cansada de cair em links falsos. Com o Hoobuy Spreadsheet tenho a segurança que precisava. Tudo verificado e organizado por categoria. Simplesmente perfeito para minhas compras!&rdquo;</p>
            <div className="flex items-center gap-1 mt-3">
              {[1,2,3,4,5].map(i => <i key={i} className="ri-star-fill text-accent-500 text-sm w-4 h-4 flex items-center justify-center"></i>)}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}